import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import {
  addActiveArea,
  fetchAreas,
  fetchAreaAll,
  fetchAreaData,
  fetchAreaPolygon,
  fetchAreaDetails,
} from '../../../store/actions/areas';

import { activateModal, updateProperties } from '../../../store/actions';

import Areas from './AreasEDCMap';

// Only pull extended data once per layer (population/polygons/etc)
const extendedDataFetched = [];

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  let { match: { params: { layer } } } = ownProps;
  layer = layer || 'states';

  const layerArray = state.areas[layer] || [];
  let detailInfoToShow = null;
  switch (layer) {
    case 'states':
      detailInfoToShow = state.viewer.areaSettings.stateInfoToShow;
      break;
    case 'counties':
      detailInfoToShow = state.viewer.areaSettings.countyInfoToShow;
      break;
    case 'communities':
      detailInfoToShow = state.viewer.areaSettings.communityInfoToShow;
      break;
    case 'regions':
      detailInfoToShow = state.viewer.areaSettings.regionInfoToShow;
      break;
    default:
      break;
  }

  const getAreaLength = (areasObj, area) => {
    let areaLength;
    if (areasObj.areas && areasObj.areas.areaAll) {
      areaLength = areasObj.areas.areaAll[`${area}`];
    }
    return areaLength;
  };

  let selectedOrgContact;
  const defaultOrgContact = (state.viewer.contact || []).reduce((primary, contact) => {
    return (contact.isPrimary || contact.isprimary) ? contact : primary;
  }, undefined);
  if (layer === 'counties') {
    const { intid } = layerArray.find(a => a.id === state.areas.activeID) || {};
    selectedOrgContact = (state.viewer.contact || []).reduce((selected, contact) => {
      if (contact.primaryFor && contact.primaryFor.includes(intid)) {
        return contact;
      }
      return selected;
    }, undefined);
  }

  return {
    active: layerArray.find(a => a.id === state.areas.activeID),
    activeColor: state.viewer.activeColor,
    loading: state.areas.areasLoading,
    backgroundColor: state.viewer.backgroundColor,
    fetched: layerArray.length > 0,
    states: state.areas.states,
    counties: state.areas.counties,
    communities: state.areas.communities,
    regions: state.areas.regions,
    layer,
    layers: state.areas.mapLayers,
    overview: state.areas.overview,
    polygon: state.areas.polygon,
    organizationId: state.organizationId,
    filters: {
      buildings: state.buildings.filters,
      sites: state.sites.filters,
    },
    sort: {
      buildings: state.buildings.sort,
      sites: state.sites.sort,
    },
    areasToShow: state.viewer.areaSettings.areasToShow,
    organizationContact: selectedOrgContact || defaultOrgContact,
    viewer: state.viewer,
    detailInfoToShow,
    countiesLength: getAreaLength(state, 'counties'),
    communitiesLength: getAreaLength(state, 'communities'),
    regionsLength: getAreaLength(state, 'regions'),
    statesLength: getAreaLength(state, 'states'),
    areaAll: state.areas.areaAll,
    measure: state.measure,
    // contacts: state.areas.areaAll.map(areaArray => areaArray.contacts),
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  const addActive = (layer, area, skipRouting) => {
    dispatch(addActiveArea(area, layer));

    if (!skipRouting) {
      if (area) {
        dispatch(push(`/areas-edc-map/${layer}/${area._id}${window.location.search}`));
      } else {
        dispatch(push(`/areas-edc-map/${layer}${window.location.search}`));
      }
    }

    if (!area) return;

    dispatch(fetchAreaDetails(layer, area));

    [
      'race',
      'population',
      'labor',
      'populationByAge',
      'futurePopulationByAge',
      'malePopulationByAge',
      'femalePopulationByAge',
      'education',
      'housing',
      'industry',
      'income',
    ].forEach(report => {
      const id = (layer === 'regions')
        ? area.counties.map(county => county.id).join()
        : area.id;
      dispatch(fetchAreaData(layer, id, report));
    });
    dispatch(fetchAreaData('national', '01', 'nationalIncome'));
  };

  return {
    getAreasAll: org => dispatch(fetchAreaAll(org)),
    getAreas: (layer, org) => {
      dispatch(fetchAreas(layer, org));
      // .then(areas => {
      //   if (areas.length) {
      //     if (extendedDataFetched.indexOf(layer) === -1) {
      //       extendedDataFetched.push(layer);
      //       dispatch(fetchAreaPolygon(layer, areas));
      //     }
      //   }
      // });
    },
    getBoundaryPolygon: (layer, org) => {
      dispatch(fetchAreas(layer, org))
        .then(areas => {
          if (areas.length) {
            if (extendedDataFetched.indexOf(layer) === -1) {
              extendedDataFetched.push(layer);
              dispatch(fetchAreaPolygon(layer, areas));
            }
          }
        });
    },
    addActive,
    addLayer: layer => addActive(layer, null),
    openModal: () => dispatch(activateModal('report')),
    routeToSubTab: (layer, id, subTab) => dispatch(push(`/areas/${layer}/${id}${subTab}`)),
    showShareModal: () => { dispatch(activateModal('share-map')); },
    showDownloadModal: () => { dispatch(activateModal('download')); },
    showModal: (modal, properties) => { dispatch(activateModal(modal, properties)); },
    addFilter: (propertyType, filters, sort, organizationId) => {
      dispatch(updateProperties(propertyType, filters, sort, organizationId));
      dispatch(push(`/${propertyType}?organization=${organizationId}`));
    },
    showSlideshow: id => { dispatch(activateModal(`slideshow-${id}`)); },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Areas);



// WEBPACK FOOTER //
// ./src/components/Areas/AreasWrapper/AreasEDCMapWrapper.js